import { render, staticRenderFns } from "./ResourcesAvailable.vue?vue&type=template&id=458d58de&scoped=true&"
import script from "./ResourcesAvailable.vue?vue&type=script&lang=js&"
export * from "./ResourcesAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d58de",
  null
  
)

export default component.exports